import { render, staticRenderFns } from "./BiobankReport.vue?vue&type=template&id=db95c90a&"
import script from "./BiobankReport.vue?vue&type=script&lang=js&"
export * from "./BiobankReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports